import React, { useState } from "react";
import { setAnalyticsChoice, getAnalyticsChoice } from "../lib/track";

export const PrivacyNotice = () => {
  const [open, setOpen] = useState(() => !getAnalyticsChoice());
  if (!open) return null;
  const choose = (v) => { setAnalyticsChoice(v); setOpen(false); };
  return (
    <div
      className="fixed z-[60] left-3 right-3 bottom-20 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-xs rounded-2xl border border-white/10 bg-[#0a1226]/95 backdrop-blur-xl p-4 shadow-2xl"
      role="dialog"
      aria-label="Privacy notice"
      data-testid="privacy-notice"
    >
      <p className="text-[12px] leading-relaxed text-zinc-300">
        We use privacy-friendly analytics to improve this site: pages visited, approximate location and a masked IP
        address (the last part is removed), kept for 90 days. No advertising cookies.
      </p>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={() => choose("yes")} data-testid="privacy-accept-btn"
          className="rounded-full bg-gradient-to-r from-[#E5C56F] to-[#C9A64B] px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-[#1a1405] hover:brightness-110 transition-[filter]">
          OK
        </button>
        <button type="button" onClick={() => choose("no")} data-testid="privacy-decline-btn"
          className="rounded-full border border-white/15 px-4 py-1.5 text-[11px] uppercase tracking-[0.15em] text-zinc-400 hover:text-zinc-200 hover:border-white/30 transition-colors">
          Decline
        </button>
      </div>
    </div>
  );
};
